import { render, staticRenderFns } from "./DormScrollPanel.vue?vue&type=template&id=ce9c3236&scoped=true"
import script from "./DormScrollPanel.vue?vue&type=script&lang=js"
export * from "./DormScrollPanel.vue?vue&type=script&lang=js"
import style0 from "./DormScrollPanel.vue?vue&type=style&index=0&id=ce9c3236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9c3236",
  null
  
)

export default component.exports